import { useState } from "react";
import styled from "styled-components";
import { register } from "../../services/AuthService";
import { useNavigate } from "react-router-dom";
import Button from "../CommonComponents/Button";
import Headline from "../MainComponents/Headline";
import { Card, Container, Input, Wrapper } from "../CommonComponents/DataCard";



const ErrorMsg = styled.p`
  color: red;
  text-align: center;
  margin: 0.5rem 0;
`;

const STATUS_OPTIONS = [
  { value: "ACTIVE", label: "Aktivan" },
  { value: "INACTIVE", label: "Neaktivan" },
  { value: "STUDENT", label: "Student" },
  { value: "RETIRED", label: "Umirovljenik" },
];

function Register({ user }) {
  const [form, setForm] = useState({
    username: "",
    name: "",
    surname: "",
    oib: "",
    address: "",
    email: "",
    telephone: "",
    status: "ACTIVE",
  });
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      await register(form);
      navigate("/korisnici");
    } catch (err) {
      if (err.message.includes("Korisnik već postoji")) {
        setError("Korisničko ime je zauzeto.");
      } else {
        setError("Greška kod registracije. Pokušajte ponovno.");
      }
    }
  };

  return (
    <Wrapper>
      <Container style={{ width: "500px" }}>
        <Card>
          <Headline size="2rem" center>Registracija</Headline>
          {error && <ErrorMsg>{error}</ErrorMsg>}
          <form onSubmit={handleSubmit}>
            <Input name="username" placeholder="Korisničko ime" value={form.username} onChange={handleChange} />
            <Input name="name" placeholder="Ime" value={form.name} onChange={handleChange} />
            <Input name="surname" placeholder="Prezime" value={form.surname} onChange={handleChange} />
            <Input name="oib" placeholder="OIB" value={form.oib} onChange={handleChange} />
            <Input name="address" placeholder="Adresa" value={form.address} onChange={handleChange} />
            <Input name="email" placeholder="Email" value={form.email} onChange={handleChange} />
            <Input name="telephone" placeholder="Telefon" value={form.telephone} onChange={handleChange} />
            <select
              name="status"
              value={form.status}
              onChange={handleChange}
              style={{ width: "100%", padding: "0.5rem", marginBottom: "1rem", fontSize: "1rem", borderRadius: "4px", border: "1px solid #ccc" }}
            >
              {STATUS_OPTIONS.map(opt => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
            <Button
              tekst="Registracija"
              sirina="100%"
              akcija={handleSubmit} />
          </form>
        </Card>
      </Container>
    </Wrapper>
  );
}

export default Register;
